// JS
// ----------------------------------------------------

// jQuery
window.$ = jQuery;
window.jQuery = jQuery;

// External Scripts
import 'core-js/actual/promise/with-resolvers';
import './scripts/bootstrap.min.js';
import 'es6-set/implement';
import 'unfetch/polyfill';
import 'jquery-inview';

// Local Scripts
import 'buyside/scripts/index';

document.addEventListener('DOMContentLoaded', () => import('shared/toasts/toasts'));
